import { useState, type FormEvent } from 'react';
import { useSession } from '@/app/session';
import { createOrganization } from '@/data/repository';
import { Button, Field, TextInput, Banner } from '@/components/ui';
import { toAppError } from '@/data/errors';

/**
 * Usuário autenticado sem nenhuma organização.
 * `app_create_organization` cria a organização e a associação de master
 * atomicamente — não dá para ficar com uma sem a outra.
 */
export function OnboardingPage() {
  const { refreshMemberships, signOut } = useSession();
  const [legalName, setLegalName] = useState('');
  const [tradeName, setTradeName] = useState('');
  const [cnpj, setCnpj] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await createOrganization({ legalName, tradeName, cnpj });
      await refreshMemberships();
    } catch (err) {
      setError(toAppError(err).message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="auth">
      <form className="auth__card" onSubmit={onSubmit}>
        <div className="auth__brand">
          <span className="brand__mark" aria-hidden>
            NR
          </span>
          <span>Criar organização</span>
        </div>
        <p className="auth__legend">
          Você ainda não pertence a nenhuma organização. Crie a primeira — você será o
          administrador.
        </p>

        {error && <Banner kind="danger">{error}</Banner>}

        <Field label="Razão social" required>
          {(id) => (
            <TextInput
              id={id}
              value={legalName}
              onChange={(e) => setLegalName(e.target.value)}
              required
            />
          )}
        </Field>

        <Field label="Nome fantasia">
          {(id) => (
            <TextInput id={id} value={tradeName} onChange={(e) => setTradeName(e.target.value)} />
          )}
        </Field>

        <Field label="CNPJ">
          {(id) => (
            <TextInput
              id={id}
              value={cnpj}
              onChange={(e) => setCnpj(e.target.value)}
              inputMode="numeric"
              placeholder="00.000.000/0000-00"
            />
          )}
        </Field>

        <Button type="submit" variant="primary" loading={busy}>
          Criar organização
        </Button>
        <Button variant="ghost" size="sm" onClick={() => void signOut()}>
          Sair
        </Button>
      </form>
    </div>
  );
}
